import React from 'react';
import { graphql } from 'gatsby';

import Seo from "../components/seo/head";
import CustomBlockAssigner from '../components/customer-block-assigner'

const CustomBlockCaseStudy = ({ data }) => {
  const { contentfulCaseStudies } = data;

  const {
    blocks
  } = contentfulCaseStudies;

  return (
    <div className={`${blocks[0]?.internal?.type !== "ContentfulHeroBlock" && "no-hero-page"} page-wrapper`}>
      { blocks && blocks.map((block, index) => {
        return(
          <CustomBlockAssigner
            block={block}
            blockIndex={index}
            key={`page-custom-block-${index}`}
          />
        )
      })}
    </div>
  )
}

export const Head = ({data, location}) => (
  <Seo
    location={location} {...data.contentfulCaseStudies.seo} 
  />
)

export default CustomBlockCaseStudy;

export const PageQuery = graphql`
  query ($id: String!) {
    contentfulCaseStudies(id: {eq: $id}) {
      title
      blocks {
        ...contentBlockFields
        ...imageBlockFields
        ...imageTextBlockFields
        ...heroBlockFields
        ...iframeBlockFields
      }
      seo {
        metaTitle
        metaDescription {
          metaDescription
        }
        robotsMetaTag
      }
    }
  }
`